// You can write more code here

/* START OF COMPILED CODE */

import Phaser from 'phaser';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class TransitionWorldShipwreckToJungle extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 960, y ?? 384);

    // leavesLeft
    const leavesLeft = scene.add.image(-1589, 0, 'game-all', 'wipe-leaves.png');
    leavesLeft.scaleX = 1.33;
    leavesLeft.scaleY = 1.33;
    this.add(leavesLeft);

    // leavesRight
    const leavesRight = scene.add.image(1589, 0, 'game-all', 'wipe-leaves.png');
    leavesRight.scaleX = 1.33;
    leavesRight.scaleY = 1.33;
    leavesRight.flipX = true;
    this.add(leavesRight);

    this.leavesLeft = leavesLeft;
    this.leavesRight = leavesRight;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private leavesLeft: Phaser.GameObjects.Image;
  private leavesRight: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  private coveredCallback: (() => void) | undefined;
  private doneCallback: (() => void) | undefined;

  public activate(coveredCallback?: () => void, doneCallback?: () => void) {
    if (coveredCallback) this.coveredCallback = coveredCallback;
    if (doneCallback) this.doneCallback = doneCallback;

    this.transitionIn();
    this.scene.time.delayedCall(500, this.transitionOut, [], this);
    if (this.doneCallback) this.scene.time.delayedCall(500, this.doneCallback);
  }

  public show() {
    this.transitionInInit();
    this.transitionIn();
  }

  public hide() {
    this.transitionOut();
  }

  public reset() {
    this.transitionInInit();
  }

  // protected init() {
  //   this.leavesLeft.x = -1589;
  //   this.leavesRight.x = 1589;
  // }

  transitionInInit() {
    this.leavesLeft.x = -1589;
    this.leavesRight.x = 1589;
    // this.leavesLeft.angle = -90;
    // this.leavesRight.angle = 90;
  }

  transitionIn() {
    this.scene.add.tween({
      targets: this.leavesLeft,
      x: -331,
      // angle: 0,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.scene.add.tween({
      targets: this.leavesRight,
      x: 331,
      // angle: 0,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out
    });
  }

  transitionOut() {
    this.coveredCallback?.();

    this.scene.add.tween({
      targets: this.leavesLeft,
      x: -1589,
      // angle: -90,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.In
    });

    this.scene.add.tween({
      targets: this.leavesRight,
      x: 1589,
      // angle: 90,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.In
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
